import { awsApiInstance } from '../api/aws-api';
import { apiRetry } from '../api/api-helper';
import useAuth from '../hooks/auth-hooks';

import { ICardGroupTerminalTax, ICardTerminalTaxResponse } from '../models/taxes.interface';
import { handleRouteError } from './route-helpers/route-error';

/**
 * Gets a list of taxes associated with a card group/terminal
 * 
 * @returns {ICardTerminalTaxResponse} the api response
 */
const GetTaxTerminalCardGroup = async ( tax: ICardGroupTerminalTax ): Promise<ICardTerminalTaxResponse> => {
  try {
    apiRetry(awsApiInstance);

    const { userId } = useAuth()!;

    const { data } = await awsApiInstance.get(`/card-group/${tax.cardgroupId}/tax`, {
      params: {
        wpID: userId,
        customerID: tax.customerId,
        cardGroupID: tax.cardgroupId,
        partnerID: tax.partnerId,
        terminalID: tax.terminalId
      }
    });

    return data
  } catch ( error ) {
    handleRouteError(error, 'Error getting terminal card group data');
    throw(error);
  }
}

export default GetTaxTerminalCardGroup;
